import { identityPromise } from "@common/lib/misc";
import React from "react";

export type LazySelectComponentProps = {
  hasMore: boolean;
  isLoading?: boolean;
  infiniteLoaderKey?: string;
  loadMore: () => Promise<void>;
};
const withStaticHOC =
  <TProps extends LazySelectComponentProps>(
    Component: React.ComponentType<TProps>
  ): React.FunctionComponent<Omit<TProps, "hasMore" | "infiniteLoaderKey" | "loadMore">> =>
  (props: TProps) => <Component {...props} infiniteLoaderKey="loader" hasMore={false} loadMore={identityPromise} />;
export default withStaticHOC;
